var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.748 17.5C22.5805 17.5 26.498 13.5825 26.498 8.75C26.498 3.91751 22.5805 0 17.748 0C12.9156 0 8.99805 3.91751 8.99805 8.75C8.99805 13.5825 12.9156 17.5 17.748 17.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.748 20.415C10.5026 20.4231 4.63111 26.2946 4.62305 33.54C4.62305 34.3455 5.27595 34.9984 6.08136 34.9984H29.4147C30.2201 34.9984 30.873 34.3455 30.873 33.54C30.865 26.2946 24.9935 20.423 17.748 20.415Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconDark);
export default __webpack_public_path__ + "static/media/user-icon-dark.39c48fbe40e5e09fc9b77ffbd0e1080a.svg";
export { ForwardRef as ReactComponent };